module.exports = __webpack_public_path__ + "img/home-kitch1.93becf79.jpg";